import { ArrayInput, TextField } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useForm } from "react-final-form";

interface Props {}

export const DriverSelectionGrid = (props: Props) => {
  const form = useForm();
  const isAllDriversSelectedState = form.getFieldState("isAllDriversSelected");

  return (
    <div
      style={{ display: isAllDriversSelectedState?.value ? "none" : "block" }}
    >
      <ProtectedElement source="selectedDrivers" label="" {...props}>
        <ArrayInput source="selectedDrivers">
          <ListIterator
            reference={resourceNames.ADMIN_DRIVERS}
            sort={{ field: "driverName", order: "asc" }}
          >
            <TextField source="driverId" label="ID" />
            <TextField
              source="driverName"
              label="resources.admin-drivers.labels.displayName"
            />
          </ListIterator>
        </ArrayInput>
      </ProtectedElement>
    </div>
  );
};
